var map = {
	"./bcompany.png": 9857,
	"./bhome.png": 8886,
	"./bmine.png": 7862,
	"./bpigeonhole.png": 1505,
	"./bproject.png": 6513,
	"./bstatistics.png": 9650,
	"./btask.png": 6613,
	"./company.png": 6698,
	"./home.png": 2297,
	"./mine.png": 328,
	"./pigeonhole.png": 8919,
	"./project.png": 7236,
	"./statistics.png": 6561,
	"./task.png": 49,
	"./wcompany.png": 9632,
	"./wmine.png": 9555,
	"./wpigeonhole.png": 8474,
	"./wproject.png": 799,
	"./wstatistics.png": 2608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9494;